
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const ValorisationCTA = () => {
  return (
    <section className="py-12 md:py-16 bg-fabre-lightbeige">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-fabre-gray mb-3 md:mb-4">
          Valorisez vos déchets dès aujourd'hui
        </h2>
        <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8 max-w-2xl mx-auto px-4">
          Nos experts vous accompagnent dans votre démarche de valorisation pour maximiser la valeur de vos déchets
        </p>
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center max-w-lg mx-auto">
          <Button asChild size="lg" className="bg-fabre-green hover:bg-fabre-darkgreen w-full sm:w-auto">
            <Link to="/contact">Contactez-nous</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen w-full sm:w-auto">
            <Link to="/sites">Nos sites de valorisation</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ValorisationCTA;
